import type { FC, PropsWithChildren } from "react";
import { Text } from "@looksrare/uikit";
import type { LogTextFCProps, LogTextProps } from "./types";

export const LogText: FC<PropsWithChildren<LogTextProps>> = (props) => <Text fontWeight={400} {...props} />;

export const LogTextHighlight: LogTextFCProps = (props) => <Text as="span" bold color="link-01" {...props} />;
